var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddToStudyResearch = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#49475A",
  d: "M25.394 24.001a7.88 7.88 0 0 0-1.67-8.568 3.92 3.92 0 0 0-1.085-4.414l2.776-2.776a2.003 2.003 0 0 0 0-2.829l-2.828-2.828a2 2 0 0 0-2.829 0L6.586 15.758a2.003 2.003 0 0 0 0 2.83l2.828 2.827a2 2 0 0 0 2.829 0l4.775-4.775a3.933 3.933 0 0 0 5.513.432 5.94 5.94 0 0 1 .647 6.93H16v4H4v2h24v-6zm-14.566-4L8 17.172l1.879-1.878 2.828 2.828zm5.172-6q.003.38.076.752l-1.955 1.955-2.828-2.828L21.173 4 24 6.828l-3.249 3.25A3.976 3.976 0 0 0 16 14.001m4 2a2 2 0 1 1 0-3.999 2 2 0 0 1 0 4m6 12h-8v-2h8z"
})));
export { SvgAddToStudyResearch as ReactComponent };
export default __webpack_public_path__ + "assets/images/addToStudyResearch.svg";